import {gql, useQuery} from 'admin/lib/apollo'

export const GET_DASHBOARD = gql`
  query GetDashboard {
    dashboard {
      needToBeBilledAccounts
      shouldNotBeBilledAccounts
      overpayingAccounts
      billedFibreAccounts
      billedWirelessAccounts
      recoverableMoney
      badDebt
      refundableMoney
      creditHeld
      writtenOffMoney
      unrecoveredMoney
      totalBalanced
      totalOwing
      totalOverdue
      totalInCredit
      groups {
        id
        name
        colour
        numOfActiveAccounts
      }
    }
  }
`
export default organisationId => {
  const {data: {dashboard = {}} = {}, error: getError} = useQuery(GET_DASHBOARD, {
    variables: {organisationId}
  })

  return {
    dashboard,
    errors: getError || {}
  }
}
